<app-mid-button type="primary" (action)="openDialog()" icon="fas fa-photo-video" [disabled]="intervention?.isArchived">
  {{ 'IMPORT_MEDIA' | translate }}
</app-mid-button>
